import React from "react";
import Header from "../components/header";
import UserNewCheckListTable from "../containers/userNew/userNewChecklistTable";

export default function UserNewCheckList() {
  return (
    <>
      <Header>Certify Tractor</Header>
      <UserNewCheckListTable />
    </>
  );
}
